import { CHANGE_PASSWORD_CONFIRM, CHANGE_PASSWORD_NEW, CHANGE_PASSWORD_OLD, ERROR_PASSWORD_CONFIRM, INITIAL_STATE_CHANGE, ONSUBMIT_PASSWORD, SHOW_PASSWORD_CONFIRM, SHOW_PASSWORD_NEW, SHOW_PASSWORD_OLD, SUBMIT_NEW_PASSWORD } from "./types";


const initiate = {
    oldPassword: "",
    password: "",
    confirmPassword: "",
    errorPassword: "",
    showPassword: false,
    showConfirmPassword: false,
    showPasswordOld: false,
    onSubmit: false,
    successSubmit: false,
}

const ChangePasswordReducer = (state = initiate, action) => {
    switch (action.type) {
        case CHANGE_PASSWORD_CONFIRM: 
            return {
                ...state,
                ...action.payload
            };
        case CHANGE_PASSWORD_NEW: 
            return {
                ...state,
                ...action.payload
            };
        case CHANGE_PASSWORD_OLD: 
            return {
                ...state,
                ...action.payload
            };
        case SHOW_PASSWORD_CONFIRM: 
            return {
                ...state,
                ...action.payload
            };
        case SHOW_PASSWORD_NEW: 
            return {
                ...state,
                ...action.payload
            };
        case SHOW_PASSWORD_OLD: 
            return {
                ...state,
                ...action.payload
            };
        case ONSUBMIT_PASSWORD: 
            return {
                ...state,
                ...action.payload
            };
        case SUBMIT_NEW_PASSWORD: 
            return {
                ...state,
                ...action.payload
            };
        case INITIAL_STATE_CHANGE:
            let reset = initiate;

            return {
                ...reset
            };
        case ERROR_PASSWORD_CONFIRM:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}

export default ChangePasswordReducer;